export const TRACKING_LEAD_QUALITY = '[tracking] Lead quality';
export const TRACKING_LEAD_QUALITY_V2 = '[tracking] Lead quality v2';
